export const LEAVE_HEADER = className => `Leave ${className}?`
export const LEAVE_NOTICE =
  "The class will no longer appear on your Second Step® account. Your progress in the class's data will remain."
export const LEAVE_CONFIRM = 'Got it'
export const LEAVE_SUBMIT = 'LEAVE CLASS'
export const LEAVE_CANCEL = 'CANCEL'
